import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { getIcon } from './helpers/icons'

import style from './style/zaptic-icon-procedure-wrench-style'

@customElement('zaptic-icon-procedure-wrench')
export class IconProcedureWrench extends LitElement {
    static style = style

    render() {
        return html`${getIcon('procedure-wrench')}`
    }
}
